<template>
  <div>
    <div
      style="
          width: 100%;
          text-align: center;
          font-size: 25px;
          font-weight: bold;
        "
    >《普通高等学校录取新生名册》查询复印服务</div>
    <div style="justify-content: center">
      <div
        style="
            margin-top: 30px;
            justify-content: center;
            margin-left: 5%;
            margin-right: 5%;
          "
      >
        <el-row justify="center" align="middle" style>
          <el-col :span="2">
            <div class="trcol">预约人</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusername }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">学号/工号</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserid }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">院系/部门</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserdepartname }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="trcol">专业</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusermajor != null ? userInfo.amusermajor : " " }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">班级</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserclass != null ? userInfo.amuserclass : " " }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">手机号码</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusertel }}</div>
          </el-col>
        </el-row>
      </div>
      <div class="form">
        <el-form ref="form" :model="form" :rules="rules" label-width="150px" v-loading="loading">
          <el-row>
            <el-col :span="24">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="姓名：" prop="name">
                    <el-input v-model="form.name" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="身份证号：" prop="idcode">
                    <el-input v-model="form.idcode"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>

            <el-col :span="24">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="手机号：" prop="studenttelephone">
                    <el-input v-model="form.studenttelephone"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="新生名册类型：" prop="rostertype">
                    <el-select
                      v-model="form.rostertype"
                      clearable
                      filterable
                      placeholder="请选择"
                      style="width: 100%"
                      @change="rosterTypeChangeDept"
                    >
                      <el-option
                        v-for="item in rosterType"
                        :key="item.key"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-col :span="12" v-if="rostertype2">
                  <el-form-item label="专升本考试年份：" prop="zsbyear">
                    <el-input v-model="form.zsbyear" placeholder="输入示例：2020"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="rostertype3">
                  <el-form-item label="高职扩招考试年份：" prop="gzkzyear">
                    <el-input v-model="form.gzkzyear" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24" v-if="rostertype1">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="参加高考年份：" prop="gkyear">
                    <el-input v-model="form.gkyear" placeholder="输入示例：2020"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="rostertype1">
                  <el-form-item label="高考所在省份：" prop="province">
                    <el-select
                      v-model="form.province"
                      clearable
                      filterable
                      placeholder="请选择"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in provinceList"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="rostertype1">
                  <el-form-item label="高中科目类型：" prop="subjecttype">
                    <el-select
                      v-model="form.subjecttype"
                      clearable
                      filterable
                      placeholder="请选择"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in subjectType"
                        :key="item.key"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="rostertype1">
                  <el-form-item label="录取批次：" prop="admissionbatch">
                    <el-select
                      v-model="form.admissionbatch"
                      clearable
                      filterable
                      placeholder="请选择"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in admissionBatch"
                        :key="item.key"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="录取专业：" prop="major">
                    <el-input v-model="form.major" placeholder="请如实填写录取时的专业，不填转专业后的专业。"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="个人邮箱：" prop="email">
                    <el-input v-model="form.email"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="领取方式：" prop="receivemethod">
                    <el-select
                      ref="receiveSelect"
                      v-model="form.receivemethod"
                      clearable
                      filterable
                      placeholder="请选择"
                      style="width: 100%"
                      @change="receiveMethodChangeDept"
                    >
                      <el-option
                        v-for="item in receiveMethod"
                        :key="item.key"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="receiveMethod2">
                  <el-form-item label="受托人姓名：" prop="trusteename">
                    <el-input v-model="form.trusteename"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="receiveMethod3">
                  <el-form-item label="收件人姓名：" prop="recipientname">
                    <el-input v-model="form.recipientname"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24" v-if="receiveMethod2">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="受托人身份证号：" prop="trusteeidcode">
                    <el-input v-model="form.trusteeidcode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="受托人手机号码：" prop="trusteetelephone">
                    <el-input v-model="form.trusteetelephone"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24" v-if="receiveMethod3">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="收件人手机号：" prop="recipienttelephone">
                    <el-input v-model="form.recipienttelephone"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="收件详细地址：" prop="recipientadress">
                    <el-input
                      v-model="form.recipientadress"
                      maxlength="50"
                      placeholder="省/市/区/详细地址"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注说明：">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入具体情况描述"
                  v-model="form.memo"
                  :autosize="{ minRows: 4, maxRows: 6 }"
                  maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item style="align-items: center; text-align: center">
                <el-button class="submitClass" @click="onSubmit('form')">提交</el-button>
                <el-button class="colseClass" @click="goBack">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
  
<script>
// import moment from 'moment'
// import { Message } from "element-ui";
import { getSysDict, save } from "@/api/admissionRosterCopy.js";
//
import { sendMsg } from "@/api/serviceInfo.js";
import { queryMatter, queryRunById } from "@/api/matter.js";
import moment from "moment";
export default {
  name: "admissionRosterCopy",
  data() {
    //校验手机号
    const validatePhone = (rule, value, callback) => {
      const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    //校验身份证号
    const validateIdCode = (rule, value, callback) => {
      const regExp = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!regExp.test(value)) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    //校验邮箱
    const validateEmile = (rule, value, callback) => {
      const regExp = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (!regExp.test(value)) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    //高考年份
    const validateGkYear = (rule, value, callback) => {
      if (this.form.rostertype === "01") {
        console.log("请输入高考年份");
        if (!value) {
          callback(new Error("请输入高考年份"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //高考所在省份
    const validateProvince = (rule, value, callback) => {
      if (this.form.rostertype === "01") {
        if (!value) {
          callback(new Error("请选择高考所在省份"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //高考科目类型
    const validateSubjecttype = (rule, value, callback) => {
      if (this.form.rostertype === "01") {
        if (!value) {
          callback(new Error("请选择高考科目类型"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //录取批次
    const validateAdmissionbatch = (rule, value, callback) => {
      if (this.form.rostertype === "01") {
        if (!value) {
          callback(new Error("请选择录取批次"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //专升本年份
    const validateZSBYear = (rule, value, callback) => {
      if (this.form.rostertype === "02") {
        if (!value) {
          callback(new Error("请输入专升本年份"));
        } else {
          callback();
        }
      }
    };
    //受托人姓名
    const validateTrusteename = (rule, value, callback) => {
      if (this.form.receivemethod === "02") {
        console.log("请输入受托人姓名", value);
        if (!value) {
          callback(new Error("请输入受托人姓名"));
        } else {
          callback();
        }
      }
    };
    //受托人身份证号
    const validateTrusteeidcode = (rule, value, callback) => {
      const regExp = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (this.form.receivemethod === "02") {
        if (!regExp.test(value)) {
          callback(new Error("请输入正确的身份证号"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //受托人手机号
    const validateTrusteeTelephone = (rule, value, callback) => {
      const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (this.form.receivemethod === "02") {
        if (!regExp.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //收件人手机号
    const validateRecipienttelephone = (rule, value, callback) => {
      const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (this.form.receivemethod === "03") {
        if (!regExp.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //收件人姓名
    const validateRecipientname = (rule, value, callback) => {
      if (this.form.receivemethod === "03") {
        if (!value) {
          callback(new Error("请输入收件人姓名"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //收件人详细地址
    const validateRecipientadress = (rule, value, callback) => {
      if (this.form.receivemethod === "03") {
        if (!value) {
          callback(new Error("请输入收件人详细地址"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      loading: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      recepuseriddisabled: true,
      recepuserlist: [],
      userInfo: {
        amuserid: "",
        amusername: "",
        amusertel: "",
        amuserdepartcode: "",
        amuserdepartname: "",
        amusermajor: "",
        amusergrade: "",
        amuserclass: ""
      },
      form: {
        userid: "",
        name: "",
        idcode: "",
        studenttelephone: "",
        rostertype: "",
        gkyear: "",
        province: "",
        subjecttype: "",
        admissionbatch: "",
        zsbyear: "",
        gzkzyear: "",
        major: "",
        email: "",
        receivemethod: "",
        trusteename: "",
        trusteeidcode: "",
        trusteetelephone: "",
        recipientname: "",
        recipienttelephone: "",
        recipientadress: "",
        memo: ""
      },

      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        rostertype: [
          { required: true, message: "请选择新生名册类型", trigger: "change" }
        ],
        province: [
          { required: true, validator: validateProvince, trigger: "change" }
        ],
        subjecttype: [
          { required: true, validator: validateSubjecttype, trigger: "change" }
        ],
        admissionbatch: [
          { required: true, validator: validateAdmissionbatch, trigger: "change" }
        ],
        zsbyear: [
          { required: true, validator: validateZSBYear, trigger: "blur" }
        ],
        gkyear: [
          { required: true, validator: validateGkYear, trigger: "blur" }
        ],
        idcode: [
          { required: true, validator: validateIdCode, trigger: "blur" }
        ],
        major: [{ required: true, message: "请输入录取专业", trigger: "blur" }],
        receivemethod: [
          { required: true, message: "请选择领取方式", trigger: "change" }
        ],
        trusteename: [
          { required: true, validator: validateTrusteename, trigger: "blur" }
        ],
        recipientname: [
          { required: true, validator: validateRecipientname, trigger: "blur" }
        ],
        recipientadress: [
          {
            required: true,
            validator: validateRecipientadress,
            trigger: "blur"
          }
        ],
        studenttelephone: [
          { required: true, validator: validatePhone, trigger: "blur" }
        ],
        trusteetelephone: [
          {
            required: true,
            validator: validateTrusteeTelephone,
            trigger: "blur"
          }
        ],
        recipienttelephone: [
          {
            required: true,
            validator: validateRecipienttelephone,
            trigger: "blur"
          }
        ],
        trusteeidcode: [
          { required: true, validator: validateTrusteeidcode, trigger: "blur" }
        ],
        email: [{ required: true, validator: validateEmile, trigger: "blur" }]
      },
      types: [],
      headers: {
        appkey: "XKES"
      },
      centerArr: [],
      receiveMethod2: false,
      receiveMethod3: false,
      rostertype1: false,
      rostertype2: false,
      rostertype3: false,
      receiveMethod: [],
      admissionBatch: [],
      subjectType: [],
      rosterType: [],
      province: [],
      provinceList: [
        "河北",
        "山西",
        "黑龙江",
        "吉林",
        "辽宁",
        "江苏",
        "浙江",
        "安徽",
        "福建",
        "江西",
        "山东",
        "河南",
        "湖北",
        "湖南",
        "广东",
        "海南",
        "四川",
        "贵州",
        "云南",
        "陕西",
        "甘肃",
        "青海",
        "台湾",
        "内蒙古",
        "广西",
        "西藏",
        "宁夏",
        "新疆",
        "北京",
        "天津",
        "上海",
        "重庆",
        "香港",
        "澳门"
      ]
    };
  },
  mounted() {
    let user = JSON.parse(sessionStorage.getItem("userInfo"));
    console.log(user);
    this.userInfo = {
      amuserid: user.userid,
      amusername: user.name,
      amusertel: user.mobile,
      amuserdepartcode: "",
      amuserdepartname: user.department,
      amusermajor: user.major,
      amusergrade: user.grade,
      amuserclass: user.bj
    };
    this.form.name = user.name;
    this.getDept();
  },
  methods: {
    open(str) {
      this.$confirm(str, "温馨提示", {
        cancelButtonText: "确定",
        showClose: false,
        showConfirmButton: false,
        showCancelButton: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        cancelButtonClass: "cancelButtonClass",
        callback: action => {
          if (action == "cancel") {
            this.$refs.receiveSelect.blur();
          }
        }
      }).then(() => {});
    },
    receiveMethodChangeDept() {
      if (this.form.receivemethod === "01") {
        let str =
          "提交申请后招生科将于2个工作日内通知您来领取，请耐心等待，其他事项可来电咨询027-88141135，祝您生活愉快！";
        this.open(str);
        this.receiveMethod2 = false;
        this.receiveMethod3 = false;
      }
      if (this.form.receivemethod === "02") {
        let str =
          "提交申请后招生科将于2个工作日内通知受托人来校领取，请耐心等待，请认真填写受托人信息，其他事项可来电咨询027-88141135，祝您生活愉快！";
        this.open(str);
        this.receiveMethod3 = false;
        this.receiveMethod2 = true;
      }
      if (this.form.receivemethod === "03") {
        let str =
          "提交申请后招生科将于2个工作日内通过“顺丰到付”的方式邮寄，请耐心等待，其他事项可来电咨询027-88141135，祝您生活愉快！";
        this.open(str);
        this.receiveMethod2 = false;
        this.receiveMethod3 = true;
      }
    },
    rosterTypeChangeDept() {
      if (this.form.rostertype === "01") {
        this.rostertype2 = false;
        this.rostertype3 = false;
        this.rostertype1 = true;
      }
      if (this.form.rostertype === "02") {
        this.rostertype1 = false;
        this.rostertype3 = false;
        this.rostertype2 = true;
      }
      if (this.form.rostertype === "03") {
        this.rostertype1 = false;
        this.rostertype2 = false;
        this.rostertype3 = true;
        this.form.gzkzyear="2019"
      }
    },
    onSubmit(form) {
      var that = this;
      this.$refs[form].validate(async valid => {
        if (valid) {
          this.form.pics = JSON.stringify(this.form.pics);
          let applicationtime = new Date();
          var formdata = {
            ...this.form,
            userid: this.userInfo.amuserid,
            applicationtime
          };
          console.log("formdata===", formdata);
          this.loading = true;
          const data = await save(formdata);
          //const data = "";
          console.log(data);
          if (data.msgCode == 0) {
            let params = {
              id: data.data.id + "-2", //事项id
              receiveUser: data.data.userid, //接收者userId
              memo:
                "您在" +
                moment(data.data.createtime).format("YYYY年MM月DD日HH点mm分") +
                "申请了【《普通高等学校录取新生名册》查询复印服务】，系统正在办理中，请耐心等待！", //消息内容
              sendUser: data.data.userid, //发送者userId
              serviceId: "1706953037240614913", //服务id
              f4: "《普通高等学校录取新生名册》查询复印服务"
            };
            console.log(params);
            sendMsg(params).then(res => {
              console.log(res);
            });
            await queryRunById(data.data.f1).then(res1 => {
              queryMatter(res1.data.f4).then(res2 => {
                if (res2.code == 0) {
                  let params1 = {
                    id: data.data.id + "-1", //事项id
                    receiveUser: res2.data[0].assigneeUser.id, //接收者userId
                    memo:
                      "您收到一个【《普通高等学校录取新生名册》查询复印服务】的待处理事项，请及时处理！", //消息内容
                    sendUser: data.data.userid, //发送者userId
                    serviceId: "1706953037240614913", //服务id
                    f4: "《普通高等学校录取新生名册》查询复印服务"
                  };
                  console.log(params);
                  sendMsg(params1).then(res => {
                    console.log(res);
                  });
                }
              });
            });

            this.$confirm(
              "您的预约已成功提交，我们会尽快受理您的预约，请及时查询微信消息通知关注预约处理进度，如有其他疑问请拨打该咨询电话：027-0999199231",
              "系统提示",
              {
                confirmButtonText: "返回主页",
                cancelButtonText: "继续预约",
                type: "success",
                center: true,
                showClose: false,
                callback: (action, instance) => {
                  this.loading = false;
                  console.log(action);
                  console.log(instance);
                  // 返回主页
                  if (action == "confirm") {
                    that.$router.push("/serviceHome");
                  }
                  // 继续反馈
                  if (action == "cancel") {
                    this.centerArr = [];
                    this.$refs["form"].resetFields();
                    this.receiveMethod1 = false;
                    this.receiveMethod2 = false;
                    this.receiveMethod3 = false;
                    this.rostertype1 = false;
                    this.rostertype2 = false;
                    this.rostertype3 = false;
                    this.form.memo = "";
                    this.form.name = this.userInfo.amusername
                  }
                },
                closeOnClickModal: false,
                closeOnPressEscape: false,
                cancelButtonClass: "cancelButtonClass",
                confirmButtonClass: "confirmButtonClass"
              }
            )
              .then(() => {
                that.from = {
                  id: "",
                  applydepname: "",
                  applyusers: "",
                  memo: "",
                  pics: "",
                  handlestate: 1
                };
                console.log(that.form);
              })
              .catch(() => {});
          }
        }
      });
    },
    getDept() {
      getSysDict("RECEIVE_METHOD").then(res => {
        let d = [];
        if (res.data !== null) {
          res.data.map(item => {
            let dict = {
              value: item.dictcode,
              label: item.dictname,
              key: item.id
            };
            d.push(dict);
          });
        }
        this.receiveMethod = d;
      });
      getSysDict("ADMISSION_BATCH").then(res => {
        let d = [];
        if (res.data !== null) {
          res.data.map(item => {
            let dict = {
              value: item.dictcode,
              label: item.dictname,
              key: item.id
            };
            d.push(dict);
          });
        }
        this.admissionBatch = d;
      });
      getSysDict("SUBJECT_TYPE").then(res => {
        let d = [];
        if (res.data !== null) {
          res.data.map(item => {
            let dict = {
              value: item.dictcode,
              label: item.dictname,
              key: item.id
            };
            d.push(dict);
          });
        }
        this.subjectType = d;
      });
      getSysDict("ROSTER_TYPE").then(res => {
        let d = [];
        if (res.data !== null) {
          res.data.map(item => {
            let dict = {
              value: item.dictcode,
              label: item.dictname,
              key: item.id
            };
            d.push(dict);
          });
        }
        this.rosterType = d;
      });
    },
    goBack() {
      this.$router.push("/serviceHome");
    }
  }
};
</script>
  
<style scoped>
.trcol {
  background-color: #d8efbf;
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.tdcol {
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.form {
  margin-left: 5%;
  border: 1px solid #dddddd;
  margin-top: 30px;
  padding: 20px;
  margin-right: 5%;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  margin-right: 10px;
}

.avatar {
  width: 100px;
  height: 88px;
  float: left;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 10px;
  line-height: 88px;
  text-align: center;
  /* display: block;  */
}

.close {
  position: absolute;
  right: 0;
  font-size: 20px;
}

.el-message-box__title {
  padding-left: 0;
  margin-bottom: 0;
  font-size: 18px;
  line-height: 1;
  color: white;
}

.el-message-box__header {
  position: relative;
  padding: 15px 15px 10px;
  background-color: #008a2c;
}

.el-message-box {
  border: 2px solid #008a2c;
  display: inline-block;
  width: 420px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  font-size: 18px;
  box-shadow: 0 2px 12px 0rgba (0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.el-button--primary {
  color: #fff;
  background-color: #008a2c;
  border-color: #008a2c;
}
.el-message-box--center .el-message-box__header {
  padding-top: 15px;
}

.colseClass {
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}

.colseClass:hover,
.colseClass:focus {
  /* padding: 9px 15px; */
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}

.submitClass,
.submitClass:focus {
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}

.submitClass:hover {
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.cancelButtonClass {
  padding: 9px 15px;
  font-size: 12px;
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}

.cancelButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.confirmButtonClass,
.confirmButtonClass:focus {
  padding: 9px 15px;
  font-size: 12px;
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}

.confirmButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}
</style>